import { CommonModule } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  Output,
} from '@angular/core';
import { AngularSvgIconModule } from 'angular-svg-icon';
import { NzToolTipModule } from 'ng-zorro-antd/tooltip';

export interface WizardSummaryFieldValue {
  label: string;
  value: string | number;
}

export interface WizardSummaryCheckbox {
  label: string;
  checked: boolean;
}

export interface WizardSummaryContent {
  items?: string[];
  fields?: WizardSummaryFieldValue[];
  badges?: string[];
  checkboxes?: WizardSummaryCheckbox[];
  questions?: WizardSummaryFieldValue[];
  description?: string;
  otherDescription?: string[];
}

export interface WizardSummarySection {
  stepIndex: number;
  stepNumber: number;
  totalSteps: number;
  title: string;
  isRequired: boolean;
  isHardStop: boolean;
  isCategory: boolean;
  content: WizardSummaryContent;
  // Names of this section's still-outstanding items, from the backend's
  // validation-status API — rendered as red text beside the section title.
  pendingHardStopNames?: string[];
  pendingRequiredNames?: string[];
}

@Component({
  selector: 'app-define-behavior-wizard-summary',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [CommonModule, AngularSvgIconModule, NzToolTipModule],
  templateUrl: './define-behavior-wizard-summary.component.html',
  styleUrl: './define-behavior-wizard-summary.component.scss',
})
export class DefineBehaviorWizardSummaryComponent {
  @Input() sections: WizardSummarySection[] = [];
  @Input() allowManageBehavior = true;
  // Ports bip-summary.component.html's rule that the Category section can
  // only be edited while the behavior is still a draft — once complete,
  // changing the category is locked (same as the legacy wizard).
  @Input() isDraft = true;
  // Whole-behavior pending-item names for the top banner (from the backend's
  // validation-status API) — kept as plain string arrays rather than the raw
  // model so this component stays presentational, matching its other inputs.
  @Input() pendingHardStopNames: string[] = [];
  @Input() pendingRequiredNames: string[] = [];
  @Output() editStep = new EventEmitter<number>();

  canEditSection(section: WizardSummarySection): boolean {
    return this.allowManageBehavior && (!section.isCategory || this.isDraft);
  }

  onEdit(section: WizardSummarySection): void {
    this.editStep.emit(section.stepIndex);
  }

  trackBySection(_index: number, section: WizardSummarySection): number {
    return section.stepIndex;
  }
}
